/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

export const createOneWayIconDataUrl = (rotate: number) => {
  let rotation = 0;
  rotation = rotate - 90;
  return (
    "data:image/svg+xml;base64," +
    btoa(`
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
        <g transform="rotate(${rotation} 36 36)">
          <path d="M0 0 C5.13791898 1.45999872 9.25819347 3.76946116 13.75 6.5625 C18.29909204 9.41605733 18.29909204 9.41605733 23 12 C23 12.66 23 13.32 23 14 C21.35451172 14.92232422 21.35451172 14.92232422 19.67578125 15.86328125 C18.22133265 16.67964917 16.76690677 17.49605756 15.3125 18.3125 C14.2306543 18.91868164 14.2306543 18.91868164 13.12695312 19.53710938 C10.08651345 21.24475358 7.07063885 22.95624395 4.10546875 24.79296875 C2 26 2 26 0 26 C0 22.7 0 19.4 0 16 C-13.2 16 -26.4 16 -40 16 C-40 14.02 -40 12.04 -40 10 C-26.8 10 -13.6 10 0 10 C0 6.7 0 3.4 0 0 Z " fill="#7F7F7F" transform="translate(45,23)"/>
        </g>
      </svg>
    `)
  );
};
